<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top border menuName="修改邮箱地址" prevUrl="/WeChat/Person/Account">
			<button v-if="mailPending" @click="mailEdit?sendMail():mailEdit=true" type="text" style="background: #eceef1;outline: none;box-shadow:none;border: none;" >{{mailEdit?'保存':'编辑'}}</button> 
		</Layout-Top>
		<!-- <Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="19">
				修改邮箱地址 
			</Col>
			<Col span="3">
				<button v-if="mailPending" @click="mailEdit?sendMail():mailEdit=true" type="text" style="background: #eceef1;outline: none;box-shadow:none;border: none;" >{{mailEdit?'保存':'编辑'}}</button> 
			</Col>
		</Row>
		<Divider style="margin-top: 0px;height: 2px;" /> -->
		<Row type="flex" justify="center" align="center">
			<Col span="1">
			</Col>
			<Col span="22" style="font-size: 18px;">
				<input :disabled="!mailEdit" v-model="person.pmail" style="background: #eceef1;height: 36px;width: 100%;border-bottom:1px solid #aCCaCC ;border-top: none;border-left: none;border-right: none;outline: none;" type="text" />
			</Col>
			<Col span="1">
			</Col>
		</Row>
		<Row type="flex" justify="center" align="center" style="height: 56px;color:#ccc ;line-height: 56px;font-size: 14px;">
			<Col span="1">
			</Col>
			<Col span="22" :style="{color:mailPending&&!mailEdit?'#ed4014':''}">
				{{mailPending&&!mailEdit?'该邮箱还未验证，请登录你的邮箱并验证.':'如果你更改了邮箱地址，你需要对邮箱地址进行验证.'}}
			</Col>
			<Col span="1">
			</Col>
		</Row>
		<Row type="flex" justify="center" align="center">
			<Col span="1">
			</Col>
			<Col span="22">
				<Button v-if="!mailEdit" @click="mailPending?sendMail():removeMail()" size="large" type="error" long>{{mailPending?'重新发送验证邮件':'解除绑定'}}</Button>
			</Col>
			<Col span="1">
			</Col>
		</Row>
		<Modal
			v-model="mailInfo"
			:mask-closable="false"
			:footer-hide="true"
			:styles="{padding:'8px'}"
			>
			<div slot="header" style="text-align: center;font-size: 18px;">
				提示信息
			</div>
			<div slot="close"></div>
			<Row type="flex" justify="center" align="center">
				<Col span="2" >
				</Col>
				<Col span="20" style="text-align: center;font-size: 18px;color: #ccc;">
					{{remove?'解除绑定成功！':'邮件已发送成功，请及时登录邮箱并验证.'}}
				</Col>
				<Col span="2" >
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" style="margin-top: 16px;">
				<Col span="8" >
				</Col>
				<Col span="8" style="text-align: center;font-size: 18px;">
					<Button @click="mailInfo=false" style="font-size: 16px;outline: none;box-shadow:none;" type="text" long>确定</Button>
				</Col>
				<Col span="8" >
				</Col>
			</Row>
		</Modal>
	</div>
</template>
<script>
	import Top from '../../assembly'
	export default {
		 components: {
			    'Layout-Top': Top
		 },
		 data(){
			return {
				mailInfo:false,
				mailEdit:false,
				mailPending:false,
				remove:false,
				person:{
					pmail:'9305520@qq.com'
				}
			}
		 },
		 methods:{
			 sendMail(){
				this.mailEdit=false;
				this.remove=false;
				this.mailInfo=true;
			 },
			 removeMail(){
				this.mailPending=true;
				this.mailEdit=true;
				this.remove=true;
				this.mailInfo=true;
			 }
		 }
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Account/Mail/index.vue